import {ResourcePageState} from './resource-page-state.service';
import {defaultIfEmpty} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {StaticPageApiModel} from '../../api/models/static-page.api.model';
import {StaticPageRestService} from '../../api/services/static-page.rest.service';

@Injectable()
export class StaticPageResolverService implements Resolve<StaticPageApiModel | null> {
  constructor(
    private readonly staticPageRS: StaticPageRestService,
    private readonly resourcePage: ResourcePageState
  ) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<StaticPageApiModel | null> {
    const lookup = (route.data['lookup'] as 'slug' | 'publicSlug' | undefined) || 'publicSlug';
    const identifier = (route.data['slug'] as string) || route.paramMap.get('slug');
    if (!identifier) {
      this.resourcePage.show('404');
      return of(null);
    }

    return this.resourcePage.load(identifier, options => lookup === 'slug'
      ? this.staticPageRS.getBySlug(identifier, options)
      : this.staticPageRS.getByPublicSlug(identifier, options)).pipe(defaultIfEmpty(null));
  }
}
